import React from 'react';
import { media } from '../data/media';
interface LogoProps {
  className?: string;
  /** Size utility classes for the circular logo. */
  size?: string;
}
export function Logo({
  className = '',
  size = 'h-14 w-14'
}: LogoProps) {
  return <img src={media.logo} alt="Les Artisans Sucrés — Chocolaterie & Alfajores artisanales" className={`${size} shrink-0 rounded-full border border-or/40 object-cover ${className}`} data-id="element-145" data-mp="3qb5tmirzibhl" />;
}